import Vue from 'vue'
import VueRouter from 'vue-router'

import Analises from './modules/analises'
import CreditoDebito from './modules/creditoDebito'
import Culturas from './modules/culturas'
import Pessoas from './modules/pessoas'
import Configuracao from './modules/configuracao'
import Relatorio from './modules/relatorios'
Vue.use(VueRouter)

let routes = [
    {
        path: '/',
        name: 'home',
        // component: require('@/views/Home').default
        component: require('@/views/Analises/Listar').default
    },
    {
        path: '/login',
        name: 'login',
        component: require('@/components/Auth/Login').default
    },
    {
        path: '/logout',
        name: 'logout',
        component: require('@/components/Auth/Logout').default
    },
];

routes = routes.concat(
    Analises,
    Culturas,
    Pessoas,
    Configuracao,
    Relatorio,
    CreditoDebito
);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router

